import React, { memo } from 'react';
import TableWithSummary from '../../../../components/table/TableWithSummary';
import Section from '../../../../components/outline/Section';
import columns from './columns';
import { COUPON_USER_LIST_TABLE_EMPTY_TEXT } from '../../../../constants/service/app/couponConstants';

const CouponGenerateUserList = (props) => {
  const { selectedUserIdList, list = [], pagination, summary, onCheckUser, getExcelDownload, getList } = props;

  return (
    <div className="coupon-generate-user-list">
      <Section className="coupon-description" title="쿠폰을 발급할 대상을 직접 지정해서 발급합니다.">
        <div className="info">선택한 유저 목록 ({selectedUserIdList.length})</div>

        <TableWithSummary
          data={list}
          totalCnt={summary.totalCnt}
          isStriped={true}
          emptyText={COUPON_USER_LIST_TABLE_EMPTY_TEXT}
          showPagination
          getList={getList}
          pagination={pagination}
          getExcelDownload={getExcelDownload}
          isUsedCheckbox={true}
          checkedIdList={selectedUserIdList}
          onCheck={(list) => onCheckUser(list)}
          columns={(utils) =>
            columns({
              ...utils,
            })
          }
        />
      </Section>
    </div>
  );
};

export default memo(CouponGenerateUserList);
